// ==============================
// index.js — React App Entry Point
// ==============================

// ----- React and App Imports -----
import React from "react";
import ReactDOM from "react-dom/client";


// ----- Global Styles -----
import "./index.css";

// ----- Main App Component -----
import App from "./App";

// ----- React Root Rendering -----
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render App with StrictMode for highlighting potential problems
root.render(
  <React.StrictMode>
        <App />
  </React.StrictMode>
);
